var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = _vm.topBarTop()
  var m1 = _vm.topBarHeight()
  var m2 = !(m1 == 0) ? _vm.topBarHeight() : null
  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      _vm.isPopup = true
    }
    _vm.e1 = function ($event) {
      _vm.isPopup = false
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
        m2: m2,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }